module.exports = __webpack_public_path__ + "static/media/brain (1).89e2fa78.svg";